import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { QUESTION_TYPE } from './constants';
import CryptoJS from 'crypto-js';
import {
  Document,
  Packer,
  Paragraph,
  HeadingLevel,
  LevelFormat,
  AlignmentType,
  TextRun
} from 'docx';

const secretKey = 'qlib secretkye for encript and decript string';

/**
 * Function encrypt and decript string
 * @param {String} str - str string
 * @returns
 */

export const encrypt = (str) => {
  const encrypted = CryptoJS.AES.encrypt(str.toString(), secretKey).toString();
  return encrypted;
};

/**
 * Function decrypt and decript string
 * @param {String} encryptedText - encryptedText string
 * @returns
 */

export const decrypt = (encryptedText) => {
  // Check if encryptedText is valid
  if (!encryptedText) {
    throw new Error('Invalid input: encryptedText is required.');
  }

  try {
    // Perform decryption
    const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);

    // Ensure the decryption is valid (bytes can be empty if the decryption fails)
    if (!bytes) {
      throw new Error('Decryption failed: Unable to decrypt the text.');
    }

    // Convert decrypted bytes to string
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    // If the decrypted string is empty, it means the decryption didn't work correctly
    if (!decrypted) {
      throw new Error('Decryption result is empty: The key may be incorrect.');
    }

    return decrypted;
  } catch (error) {
    console.error('Error during decryption:', error);
    throw new Error('Decryption failed: ' + error.message);
  }
};

/**
 * Function parses jwt token and returns info
 * @param {String} token - jwt string
 * @returns
 */

export const parseJwt = (token = '') => {
  if (!token) {
    return {};
  }
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (err) {
    return {};
  }
};

/**
 * Function converts date string into format DD MonthName Year
 * @param {String} date - date string
 * @returns
 */
export const parseDateString = (date = '') => {
  if (!date) {
    return '';
  }

  const dateObject = new Date(date);
  const month = dateObject.toLocaleString('default', { month: 'short' });

  return `${dateObject.getDate()} ${month} ${dateObject.getFullYear()}`;
};

export const setSelectedQuestion = (data) => {
  let questionIds = [];

  data.forEach((category) => {
    let catlist = [];
    category.subcategories.forEach((subcategory) => {
      subcategory.questions.forEach((question) => {
        catlist.push(question.precode);
      });
    });
    questionIds.push(catlist);
  });
  return questionIds;
};
export const setUpdatedQuestion = (data) => {
  let copydata = [...data];
  copydata.forEach((category) => {
    category.subcategories.forEach((subcategory) => {
      subcategory.questions.forEach((question) => {
        question.precode = `${category.id}_${subcategory.id}_${question.id}`;
        (question.category = category.title), (question.subcategory = subcategory.title);
      });
    });
  });
  return copydata;
};

export const filterQuestionsById = (data, questionIdArr) => {
  return data
    .map((category, index) => ({
      ...category, // Keep other properties in category
      subcategories: category.subcategories
        .map((subcategory) => ({
          ...subcategory, // Keep other properties in subcategory

          questions: subcategory.questions.filter((question) =>
            questionIdArr[index].includes(question.precode)
          )
        }))
        .filter((subcategory) => subcategory.questions.length > 0) // Filter out subcategories without questions
    }))
    .filter((category) => category.subcategories.length > 0); // Filter out categories without subcategories
};

export const flattenData = (data) => {
  const flattened = [];
  let qno = 0;
  data.forEach((category) => {
    // flattened.push({ categoryTitle: category.title });
    category.subcategories.forEach((subcategory) => {
      subcategory.questions.forEach((question) => {
        qno = qno + 1;
        flattened.push({
          QNo: `Q${qno}`,
          // questionTitle: question.title,
          questionText: question.text,
          instruction: QUESTION_TYPE[question.type - 1],
          categoryTitle: category.title,
          categorysubTitle: subcategory.title
          // questionTitle: question.title
        });
        flattened.push({
          questionText: question.instruction
        });
        question.options.forEach((option) => {
          flattened.push({
            QNo: option.preCode,
            questionText: option.text
          });
        });
        flattened.push({ QNo: '' });
      });
    });
  });

  return flattened;
};

export const exportTableToExcel = (tableID, filename = 'data.xlsx') => {
  const fn = removeWhiteSpace(filename);
  let table = document.getElementById(tableID);
  let wb = XLSX.utils.book_new();
  let ws = XLSX.utils.table_to_sheet(table);

  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fn}.xlsx`);
};

export const excelDownloader = (data, filename, setLoader) => {
  setLoader(true);
  const worksheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(blob, `${filename}.xlsx`);

  setTimeout(() => {
    setLoader(false);
  }, 500);
};

export const wordDownload = async (questionData, filename, setLoader) => {
  setLoader(true);
  const doc = new Document({
    numbering: {
      config: [
        {
          reference: 'my-numbering',
          levels: [
            {
              level: 0,
              format: LevelFormat.DECIMAL,
              text: '%1.',
              alignment: AlignmentType.START,
              style: {
                paragraph: {
                  indent: { left: 720, hanging: 260 }
                }
              }
            },
            {
              level: 1,
              alignment: AlignmentType.START,
              style: {
                paragraph: {
                  indent: { left: 1440, hanging: 360 }
                }
              }
            }
          ]
        }
      ]
    },
    sections: [
      {
        properties: { font: 'Arial' },
        children: questionData?.flatMap((item) => [
          new Paragraph({
            children: []
          }),
          new Paragraph({
            text: item.title,
            heading: HeadingLevel.HEADING_1
          }),

          ...item.subcategories.flatMap((subcategory) => [
            ...subcategory.questions.flatMap((question) => [
              new Paragraph({
                children: []
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: question.text,
                    font: 'Arial',
                    bold: true
                  }),
                  new TextRun({
                    text: `   (${QUESTION_TYPE[question.type - 1]})`,
                    font: 'Arial',
                    italics: true
                  })
                ],
                numbering: {
                  reference: 'my-numbering', // Correct numbering reference
                  level: 0 // Use level 0 since that’s what you configured
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `             ${question.instruction}`,
                    font: 'Arial',
                    italics: true
                  })
                ]
              }),

              ...question.options.map(
                (option) =>
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: `${option.preCode} - ${option.text}`, // Add tab before text
                        font: 'Arial'
                      })
                    ],
                    numbering: {
                      reference: 'my-numbering', // Correct numbering reference
                      level: 1 // Use level 0 since that’s what you configured
                    }
                  })
              )
            ])
          ])
        ])
      }
    ]
  });

  // Create a buffer and save the file
  const buffer = await Packer.toBuffer(doc);
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  });

  saveAs(blob, `${filename}.docx`);
  setTimeout(() => {
    setLoader(false);
  }, 500);
};

export const filterObj = (
  values,
  filtersData,
  selectedQues,
  selectedQuestionaire,
  isExcel = false,
  selectedQuesCrossTab = ''
) => {
  const filters = filtersData
    ?.map((item) => {
      if (values[item.id]) {
        return {
          key: item.id,
          value: values[item.id]
        };
      }
      return null;
    })
    .filter((filter) => filter !== null);

  const finalfilter = filters.filter((item) => item.value.length > 0);
  if (isExcel) {
    const transformedData = { qusetionnaireId: selectedQuestionaire, filters: finalfilter };
    return transformedData;
  }
  const transformedData = {
    QusetionnaireId: selectedQuestionaire,
    qId: selectedQues,
    cqId: selectedQuesCrossTab,
    filters: finalfilter
  };
  return transformedData;
};

export const createSingleData = (datanew) => {
  const transformedData = {
    qText: datanew.options.map((option) => option.name),
    options: {
      name: datanew.qText[0],
      data: datanew.options.map((option) => option.data[0]),
      count: datanew.options.map((option) => option.count[0]),
      showInLegend: false
    }
  };
  return transformedData;
};
export const filterZeroValue = (cdata, showInLegend) => {
  const copycdata = [...cdata];
  const filteredData = copycdata.map((item) => {
    const { name, data } = item;
    const fData = data.filter((item) => item > 0);
    return { name: name, data: fData, showInLegend: !showInLegend };
  });
  return filteredData;
};
export const createChartData = (type, data, chartHeight, selectedQuesCrossTab) => {
  const questionLength = data.qText.length;
  let dynamictype = type;
  let noofBar = 0;

  // const datanew = questionLength > 1 ? data : createSingleData(data);
  const datanew = questionLength > 1 ? data : createSingleData(data);

  let columnSetting = {
    pointPadding: 0,
    borderWidth: 0
    // stacking: 'stacking'
  };
  let seriesoption = {
    dataLabels: {
      // format: '{y} %',
      enabled: true,
      formatter: function () {
        let index = this.point.index;
        let count = this.series.options?.count[index];
        return `${this.y} % <span style="font-weight: normal; display:none;">, (N: ${
          count !== undefined ? count : 'N/A'
        })</span>`;
      },
      style: {
        fontFamily: 'Poppins'
      }
    }
  };
  // let tooltipdata = {
  //   headerFormat: '<b>{point.y}%</b><br>',
  //   pointFormat: ''
  // };

  const { qText, options: qoption, qType = 0 } = datanew;
  if (qType === 4 || selectedQuesCrossTab != '') {
    seriesoption = { ...seriesoption, stacking: 'normal' };
  }

  let qoptionData = [qoption];
  if (data.qText.length > 1) {
    qoptionData = qoption;
    noofBar = qoption[0].data.length * 1.5;
    if (qType === 4) {
      noofBar = qoption[0].data.length;
    }
    if (qoption[0].data.length > 7) {
      dynamictype = 'bar';
    }
  } else {
    noofBar = qoption?.data.length;
    if (qoption?.data.length > 7) {
      dynamictype = 'bar';
    }
  }
  // const filtereddata = filterZeroValue(qoptionData, questionLength === 1);

  const filtereddata = qoptionData;
  const options = {
    chart: {
      type: dynamictype,
      height: dynamictype === 'bar' ? noofBar * 60 : chartHeight - 50
    },
    credits: {
      enabled: false
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      categories: qText,
      crosshair: true
    },
    legend: {
      verticalAlign: 'top'
    },
    yAxis: {
      min: 0,
      labels: {
        enabled: false // Disables the Y-axis labels
      },
      title: {
        text: ''
      },
      gridLineWidth: 0, // Removes the horizontal grid lines
      lineWidth: 0, // Removes the Y-axis line itself
      tickWidth: 0 // Removes the ticks on the Y-axis
    },
    tooltip: {
      backgroundColor: '#ffffff',
      borderColor: '#7438f2',
      borderRadius: 10,
      borderWidth: 2,
      style: {
        color: '#333',
        fontSize: '14px',
        width: 250
      },
      formatter: function () {
        let index = this.point.index;
        let count = this.series.options?.count[index];
        return `<b>${this.x}</b><br/><span style="color:${this.point.color}">●</span> ${
          this.series.name
        }  =  <span style="font-weight: 500; font-familiy: 'Poppins'"><b>${this.y}% (N: ${
          count !== undefined ? count : 'N/A'
        })</b></span>`;
      },
      shadow: true,
      useHTML: false,
      shared: false,
      maxWidth: 250
    },
    plotOptions: {
      column: columnSetting,
      series: seriesoption,
      bar: {
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: 'Poppins'
          },
          formatter: function () {
            let index = this.point.index;
            let count = this.series.options?.count[index];
            if (this.y != 0) {
              return `${this.y} %<span style="font-weight: normal; display:none;">, (N: ${
                count !== undefined ? count : 'N/A'
              })</span>`;
            } else {
              return null;
            }
          }
        }
      }
    },
    series: filtereddata, //qoptionData,
    noData: {
      style: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#7438f2'
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
        x: 0,
        y: 0
      },
      text: 'No data available'
    }
  };
  // console.log('options', options);
  return options;
};

const groupByStack = (data) => {
  const grouped = {};

  data.forEach(({ name, data, stack, count }) => {
    if (!grouped[name]) {
      grouped[name] = { stack: [], name };
    }

    grouped[name].stack.push({
      [stack]: { data, count }
    });
  });

  return Object.values(grouped);
};
export const createTabledata = (data, isMultiTable) => {
  // console.log(isMultiTable, data);
  let groupbystack = [];
  if (isMultiTable) {
    groupbystack = groupByStack(data.options);

    // console.log('groupbystack', groupbystack);
    // Object.keys(groupbystack).forEach(function (key) {
    //   console.log(key, groupbystack[key]);
    //   groupbystack[key].forEach(function(data) {

    //   })
    // });
    const finaldata = {
      crossMulti: { quesText: data.qText, groupbystack }
    };
    return finaldata;
  }

  if (data.hasOwnProperty('options')) {
    if (data.options.length > 7) {
      // console.log('kkkkkkkkkk2', data.options);
      const result = {
        columns: [
          {
            title: 'Option',
            dataIndex: 'option',
            key: 'option',
            width: '45%'
          }
        ],
        tableData: []
      };

      // Add columns dynamically based on the "qText" (questions)
      if (data.qText) {
        data.qText.forEach((question, index) => {
          result.columns.push({
            title: question,
            dataIndex: `q${index}`,
            key: `q${index}`,
            render: (data) => {
              const dataarr = data.split('$$$$');
              return (
                <>
                  {dataarr[0]} {dataarr[1] && <small>{dataarr[1]}</small>}
                </>
              );
            }
          });
        });
      }

      // Create rows dynamically based on the "options" data (each option will be in a row)
      if (data.options) {
        data.options.forEach((option, index) => {
          const rowData = {
            key: index,
            option: option.name
          };
          // Add the value (percentage) for each option in the second, third, etc. columns
          if (data.qText) {
            data.qText.forEach((question, qIndex) => {
              const count = option.count[qIndex];
              rowData[`q${qIndex}`] =
                option.data[qIndex] +
                '%' +
                ` $$$$(N: ${count && count !== undefined ? count : 'N/A'})`;
            });
          }

          result.tableData.push(rowData);
        });
      }

      return result;
    } else {
      const result = {
        columns: [
          {
            title: 'Question',
            dataIndex: 'question',
            key: 'question',
            width: '45%'
          }
        ],
        tableData: []
      };

      // Create columns dynamically based on the "options" names
      if (data.options) {
        data?.options.forEach((option, index) => {
          result.columns.push({
            title: option.name,
            dataIndex: `option${index}`,
            key: `option${index}`,
            render: (data) => {
              const dataarr = data.split('$$$$');
              return (
                <>
                  {dataarr[0]} {dataarr[1] && <small>{dataarr[1]}</small>}
                </>
              );
            }
          });
        });
      }

      // Loop through qText to create the table data
      if (data.qText) {
        data?.qText.forEach((question, index) => {
          const rowData = {
            key: index,
            question: question
          };

          // Add option data for each question

          data.options.forEach((option, optIndex) => {
            const count = option.count[index];

            rowData[`option${optIndex}`] =
              option.data[index] +
              '%' +
              `  $$$$(N: ${count && count !== undefined ? count : 'N/Aa'})`;
          });

          result.tableData.push(rowData);
        });
      }

      return result;
    }
  } else {
    return { columns: [], tableData: [] };
  }
};

export const getBaseValue = (allques, selectedId) => {
  if (selectedId === '') {
    return '';
  }
  const selectedQuestion = allques.find((item) => item.id === selectedId);

  return selectedQuestion.base;
};

export const getAdjacentObjectId = (arr, currentId, direction = 'next') => {
  const currentIndex = arr.findIndex((item) => item.id === currentId);

  if (currentIndex === -1) {
    return undefined;
  }
  let adjacentIndex;
  if (direction === 'next') {
    adjacentIndex = currentIndex + 1;
  } else if (direction === 'previous') {
    adjacentIndex = currentIndex - 1;
  } else {
    return undefined;
  }

  if (adjacentIndex < 0 || adjacentIndex >= arr.length) {
    return undefined;
  }
  return arr[adjacentIndex].id;
};

export const getFirstAndLastQuestionId = (questions) => {
  if (questions.length === 0) {
    return { firstQuestionId: null, lastQuestionId: null };
  }
  const firstQuestionId = questions[0].id;
  const lastQuestionId = questions[questions.length - 1].id;

  return {
    firstQuestionId,
    lastQuestionId
  };
};

export const isObjectBlank = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const downloadExcel = (data, fileName) => {
  const workbook = XLSX.utils.book_new();

  data.forEach((questionSet) => {
    let sheetData = [];

    if (questionSet.options.length > 7) {
      sheetData.push([...questionSet.qText]);
      // Case 1: If there are more than 7 options, "Options" will be in the first column
      const headerRow = ['Option', 'Resp %', 'N'];
      sheetData.push(headerRow);

      questionSet.options.forEach((option) => {
        let rowData = [option.name];

        questionSet.qText.forEach((_, qIndex) => {
          const count = option.count[qIndex] || 'N/A';
          // rowData.push(`${option.data[qIndex]}% (Count: ${count})`);
          rowData.push(`${option.data[qIndex]}%`);
          rowData.push(count);
        });

        sheetData.push(rowData);
      });
    } else {
      // Case 2: If 7 or fewer options, "Questions" will be in the first column
      // const headerRow = ['Question', ...questionSet.options.map((opt) => opt.name)];
      const headerRow = ['Question', ...questionSet.options.flatMap((opt) => [opt.name, 'N'])];

      // console.log('headerRow', headerRow);

      sheetData.push(headerRow);

      questionSet.qText.forEach((qText, qIndex) => {
        let rowData = [qText];

        questionSet.options.forEach((option) => {
          const count = option.count[qIndex] || 'N/A';
          // rowData.push(`${option.data[qIndex]}% (Count: ${count})`);
          rowData.push(`${option.data[qIndex]}%`);
          rowData.push(count);
        });

        sheetData.push(rowData);
      });
    }
    // console.log('sheetData', sheetData);
    const baseRow = ['Base', questionSet.base];
    sheetData.push(baseRow);

    // Convert array to worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    const baseCell = worksheet[XLSX.utils.encode_cell({ r: sheetData.length - 1, c: 0 })];
    if (baseCell) {
      baseCell.s = { font: { bold: true } };
    }
    XLSX.utils.book_append_sheet(workbook, worksheet, `${questionSet?.surveyQId}`);
  });

  // Write and download the file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export const processChartData = (cdata) => {
  const { chartDataCrossTab: apiResponse } = cdata;
  const { base, crossQId, qType, surveyQId, title } = apiResponse;

  const qText = apiResponse.qText; // X-axis categories
  const series = {};

  apiResponse.options.forEach((option) => {
    const { name, data, stack } = option;

    if (!series[name]) {
      series[name] = {};
    }

    if (!series[name][stack]) {
      series[name][stack] = Array(qText.length).fill(0);
    }

    data.forEach((value, index) => {
      series[name][stack][index] += value;
    });
  });

  // Convert series object into Highcharts-friendly format
  const formattedSeries = [];
  Object.keys(series).forEach((name) => {
    Object.keys(series[name]).forEach((stack) => {
      formattedSeries.push({
        name: name,
        data: series[name][stack],
        stack: stack,
        count: series[name][stack]
      });
    });
  });

  return {
    chartDataCrossTab: { qText, options: formattedSeries, base, crossQId, qType, surveyQId, title }
  };
};

export const removeWhiteSpace = (str) => {
  return str.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '_');
};
